import React, {useState,useEffect} from 'react';
import { ActivityContainer } from '../others-component/ActivityContainer';
import {Paper, Typography, Box, Divider, IconButton, useTheme, LinearProgress} from '@mui/material';
import style from '../../css/Activity.module.css';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { useSelector } from 'react-redux';
import { data } from '../../storeredux';
import { RefreshRounded } from '@mui/icons-material';

export default function Activity(props){
  const { setError } = props;
  const theme = useTheme();
  const AutoPlayPlayer = autoPlay(SwipeableViews)
  const [activity, setActivity]=useState([]);
  const [nPage, setNPage] = useState(1)
  const [statePage,setStatePage] = useState(0)
  const [index,setIndex] = useState(0);
  const [loading,setLoading] = useState(true)
  const activitywd = useSelector(data)

  useEffect(() => {
    setLoading(true)
    var length = activitywd['activity'].length
    if (length > 0)
      setNPage(Math.ceil(length / 20))
    var st = statePage*20
    var dtraw = activitywd['activity'].slice(st,st+20)
    setActivity(dtraw)
    setLoading(false)
  },[activitywd])

  const refresh = () => {
    setLoading(true)
    if (statePage+1 < nPage) {
      var st = (statePage+1)*20
      setActivity(activitywd['activity'].slice(st,st+20))
      setStatePage(statePage+1)
    } else {
      setActivity(activitywd['activity'].slice(0,20))
      setStatePage(0)
    }
    setLoading(false)
  }

  const visible = () => (
    <Paper elevation={10} style={{borderRadius:20,backgroundColor:'#ffb380',padding:'15px'}}>
      <Box justifyContent='center' alignItems='center' display='flex' style={{minHeight:'inherit',position:'relative'}}>
        <Typography variant='h5' style={{width:'100%', color:'#ff6600',textAlign:'center'}}>
          <b>No Data</b>
        </Typography>
      </Box>
    </Paper>
  )

  const loadinit = () => (
    <Paper elevation={10} style={{borderRadius:20,backgroundColor:'#595959',padding:'15px'}}>
      <Box justifyContent='center' alignItems='center' display='flex' style={{minHeight:'inherit',position:'relative'}} sx={{flexWrap:'wrap',color:'white'}}>
        <LinearProgress color="inherit" sx={{width:'100%'}}/>
        <Typography variant='h6' color="inherit">Loading</Typography>
      </Box>
    </Paper>
  )

  return(
    <Box id='Activity' className={style.main}>
      <Box id='tit-oact' flexWrap='wrap' justifyContent='flex-end' alignItems='flex-end' display='flex'
          sx={{marginTop: '40px',width:'100%',marginBottom:'40px'}}>
        <Box sx={{backgroundColor:'#66ff66', top:'40px', left:'26vw',
          height: '50px', width: {xs:'30vw',md:'10vw'}, position:'relative', zIndex:-1}}/>
        <Box sx={{backgroundColor:'#66ff33', top: {xs:'80px',md:'-40px'},left:'18vw',
          height: '50px', width: {xs:'40vw',md:'10vw'}, position:'relative', zIndex:-1}}/>
        <Box style={{display:'flex'}}>
          <Typography variant='h3' style={{backgroundColor:'#33cc33'}}>
            <span className={style.titleMain}><b>Our Activity</b></span>
          </Typography>
        </Box>
        <Divider style={{width:'100%',backgroundColor:'#33cc33',height:'5px'}}/>
      </Box>
      <Box id='act-cont' className={style.submain}>
        {
          (activity.length > 0)? 
            <AutoPlayPlayer 
              interval={30000}
              axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={index}
              onChangeIndex={(i) => {setIndex(i)}}
              enableMouseEvents>
              {
                activity.map((a,y) => (
                  <Box key={y} sx={{padding:'10px',display:'flex',alignItems:'center',justifyContent:'center'}}>
                    <ActivityContainer
                      index={y}
                      setError={setError}
                      title={a.title}
                      images={(a.images && a.images.length > 0)? a.images:[]}
                      descTitle={a.descTitle}
                      rilis={a.rilis}
                      descMain={a.descMain}
                      clr={y%4}
                    />
                  </Box>
                ))
              }
            </AutoPlayPlayer>:
            <Box justifyContent='center' alignItems='center' display='flex' className={style.cardAct}>
              <Box style={{width:'100%', paddingRight: '15px',paddingLeft:'15px'}}>
                {
                  (loading)?loadinit():visible()
                }
              </Box>
            </Box>
        }
      </Box>
      <Box className={style.submain} sx={{width:'100%',marginTop:'40px'}}>
        <IconButton color='primary' onClick={() => {refresh()}}>
          <RefreshRounded fontSize='large'/>
        </IconButton>
      </Box>
    </Box>
  )
}
